import toast from "react-hot-toast";
export const triggerNotifier = ({ type, message, duration, icon }) =>
  toast[type](typeof message === "string" ? message : "Something went wrong!", {
    duration: 1000,
    icon,
  });
